import React, { useState } from "react";
import { makeStyles, Grid, Typography } from "@material-ui/core/";
import TopPart from "../../Components/TopPart/TopPart";
import CardContent from "../../Components/CardContent/CardContent";
import Experience from "../../Components/Experience/Experience";
import midPart from "./midPart";
import { addAddressLatLng } from "../../Actions/RoomDataAction";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
function HomePage() {
  const bg = require("../../Asset/Image/home.jpg");
  const gb = require("../../Asset/Image/321.jpg");
  const useStyles = makeStyles((theme) => ({
    TopPartDiv: {
      padding: "0 6% 20px 6%",
      backgroundSize: "cover",
      height: "90vh",

      [theme.breakpoints.down(1030)]: {
        height: "70vh",
      },
      backgroundImage: "url(" + bg + ")",
    },

    DuLichGanNha: {
      position: "relative",
      [theme.breakpoints.up("lg")]: {
        top: "35vh",
        justifyContent: "center",
      },
      [theme.breakpoints.between("md", 1400)]: {
        top: "27vh",
        justifyContent: "flex-start",
      },
      [theme.breakpoints.between("sm", 950)]: {
        top: "20vh",
        justifyContent: "flex-start",
      },
      [theme.breakpoints.down("xs")]: {
        top: "25vh",
        justifyContent: "flex-start",
      },
    },

    midPart: {
      padding: "4% 6%",
    },

    OBatCuDau: {
      padding: "0 6% 3% 6%",

      fontSize: "40px",
      fontWeight: "bold",
    },

    CardContentDiv: {
      padding: "0 6% 6% 6%",
      alignItems: "center",
    },

    ExperienceDiv: {
      margin: "0 auto",
      padding: "6% 6% 6% 6%",
      backgroundSize: "cover",
      backgroundColor: "black",
    },
    MidPartImg: {
      borderRadius: 10,
      height: 60,
      width: 60,
    },
  }));

  const classes = useStyles();

  return (
    <div>
      <div className={classes.TopPartDiv}>
        <div className={classes.DuLichGanNha}>
          <TopPart />
        </div>
      </div>
      <Grid container xs={12} className={classes.midPart}>
        {midPart.map((props, id) => {
          return (
            <MidPart
              key={id}
              place={props.place}
              time={props.time}
              src={props.src}
              lat={props.lat}
              lng={props.lng}
            />
          );
        })}
      </Grid>
      <Typography className={classes.OBatCuDau}>Ở bất cứ đâu</Typography>
      <div className={classes.CardContentDiv}>
        <CardContent />
      </div>
      <div className={classes.ExperienceDiv}>
        <Experience />
      </div>
    </div>
  );

  function MidPart(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    return (
      <Grid
        container
        xs={12}
        sm={6}
        md={4}
        lg={3}
        style={{ marginTop: 20 }}
        onClick={() => {
          history.push("/place");
          dispatch(
            addAddressLatLng([props.place, { lat: props.lat, lng: props.lng }])
          );
        }}
      >
        <Grid item xs={3}>
          <img
            className={classes.MidPartImg}
            src={props.src}
            alt="Home Picture"
          />
        </Grid>
        <Grid alignItems="center" container item xs={9}>
          <div item>
            <Typography style={{ fontSize: 15, fontWeight: "bold" }}>
              {props.place}
            </Typography>
            <Typography>{props.time}</Typography>
          </div>
        </Grid>
      </Grid>
    );
  }
}
export default HomePage;
